import { setAll, setArt, setEdu, setOrganization, setPro } from "../redux/licenseSlice";
import * as API from "./service";

export const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/; // 휴대폰번호
export const regTel = /^\d{2,3}-?\d{3,4}-?\d{4}$/; // 일반전화번호
export const regEmail = /^[^\sㄱ-ㅎㅏ-ㅣ가-힣]*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/; // 이메일
export const regPassword = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{4,}$/; // 비밀번호 4자리 이상 영문,숫자,특수문자 혼합
export const regPassword_Re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/; // 비밀번호 8~15자리 영문,숫자,특수문자 혼합

export const chunkFunc = (data = [], size = 1) => {
  const arr = [];

  for (let i = 0; i < data.length; i += size) {
    arr.push(data.slice(i, i + size));
  }

  return arr;
}

export const numFormat = (num, cut = 0) => {
  if (num) {
    if (cut) num = Math.floor(num / cut) * cut; // 1000 = 백원단위 절삭
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
};

export const refreshLicenseData = async (dispatch, idx) => {
  try {
    const res = await API.get(`license/user/${idx}`);
    console.log("refresh, data : ", res.data);
    const pro = res.data.filter(item => item.licenseGroup?.licenseCategory === 0);
    const art = res.data.filter(item => item.licenseGroup?.licenseCategory === 1);
    const all = res.data.filter(item => item.licenseGroup?.licenseCategory === 2);
    const edu = res.data.filter(item => item.licenseGroup === null || item.licenseGroup?.licenseCategory === 3);
    // dispatch(setPro(pro));
    dispatch(setArt(art));
    dispatch(setAll(all));
    dispatch(setEdu(edu.length > 0 ? edu[0] : undefined));

    const free = await API.get(`license/user/free/${idx}`);
    if (free.data) {
      const sum = pro ? [...pro, free.data] : free.data;
      dispatch(setPro(sum));  
    } else {
      dispatch(setPro(pro));
    }

    const organizations = await API.get(`organization/user/${idx}`);
    dispatch(setOrganization(organizations.data));

  } catch (error) {
  }
}